
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["feather feather-codepen",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","class":"feather feather-codepen"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 2l10 6.5v7L12 22 2 15.5v-7L12 2zM12 22v-6.5"}}),_c('path',{attrs:{"d":"M22 8.5l-10 7-10-7"}}),_c('path',{attrs:{"d":"M2 15.5l10-7 10 7M12 2v6.5"}})])
          )
        }
      }
    